/** User-facing labels for HR self-service portals (ESS / MSS expanded). */
export const HR_EMPLOYEE_SELF_SERVICE_TITLE = 'Employee Self-Service';
export const HR_EMPLOYEE_SELF_SERVICE_NAV = 'Employee Self-Service';
export const HR_MANAGER_SELF_SERVICE_TITLE = 'Manager Self-Service';
export const HR_MANAGER_SELF_SERVICE_NAV = 'Manager Self-Service';

export const HR_EMPLOYEE_SELF_SERVICE_PATH = '/hr/ess';
export const HR_MANAGER_SELF_SERVICE_PATH = '/hr/mss';
